import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Config } from 'common/config'

declare global {
  interface Window {
    gtag: (
      command: 'js' | 'config' | 'event',
      targetId: string,
      config?: Record<string, unknown>,
    ) => void
  }
}

const GA_ID = Config.General.gAnalyticId

export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    if (!window.gtag) return

    window.gtag('config', GA_ID, {
      page_path: location.pathname + location.search,
    })
  }, [location])
}
